import React from 'react';
import { connect } from 'react-redux';
import { Actions as FACILITYACTIONS } from '../../store/actions/facilityActions';
import { Button } from '../ui/button';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle, DialogBody } from '../ui/dialog';

const Modal = ({ facilities, facility, showFacilityModal, facilityDataModal, onConfirm, setEditing }) => {
  const primaryFacility = facilities?.find((item) => item.isPrimary === 'yes')?.name;
  const open = !!facilityDataModal?.status;

  if (!open) return null;

  const handleClose = () => showFacilityModal(false);

  return (
    <Dialog
      open={open}
      onOpenChange={(next) => {
        if (!next) handleClose();
      }}>
      <DialogContent onClose={handleClose} className='max-h-[90vh] overflow-y-auto sm:max-w-lg font-body'>
        <DialogHeader>
          <DialogTitle className='font-body'>Primary Facility</DialogTitle>
        </DialogHeader>
        <DialogBody className='text-sm text-foreground'>
          <p className='leading-relaxed'>
            <strong className='text-foreground'>{primaryFacility}</strong> is already assigned as your Primary Facility. Do
            you want to change it for <strong className='text-foreground'>{facility ? facility.name : 'this facility'}</strong>?
          </p>
        </DialogBody>
        <DialogFooter className='gap-2'>
          <Button
            variant='default'
            onClick={() => {
              onConfirm();
              setEditing(false);
              handleClose();
            }}>
            Yes
          </Button>
          <Button variant='outline' onClick={handleClose}>
            No
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

const mapStateToProps = (state) => {
  return {
    facilityDataModal: state.facilityDataModal,
    facilities: state.facility?.list,
  };
};

const mapDispatchToProps = (dispatch) => ({
  showFacilityModal: (status) => dispatch(FACILITYACTIONS.showFacilityModal(status)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Modal);
